var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',[_c('van-col',{staticClass:"cell1",attrs:{"span":"5"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('van-col',{staticClass:"cell2",attrs:{"span":"19"}},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb57a6a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/valuecell.vue
// module id = M+Ie
// module chunks = 0